import React from "react";

import "./Hero.css";

export default function Hero({image, children, pos}){

    if(!pos){
        pos = "center";
    }

    return (
        <div className="heroNoSlide" style={{backgroundImage: `url("https://api.vanarts.com/assets/${image}")`,backgroundPosition: pos}}>
            {children}
        </div>
    )
}